import React from 'react';
import Divider from '@material-ui/core/Divider';

const VerticalDivider = () => (
  <Divider
    orientation="vertical"
    flexItem
    style={{ margin: '0 8px', width: 1, backgroundColor: '#0D004D26' }}
  />
);

export default VerticalDivider;
